import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import environment from '@environment';
import { Button } from 'components/buttons/button';
import { ButtonSize, ButtonType } from 'components/buttons/button-types';
import { Card } from 'components/cards/card';
import { CardThemeType } from 'components/cards/card-type';

const ErrorPanel = observer(({ error, resetErrorBoundary, showError = true }: any) => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <Card backgroundType={CardThemeType.Glass} classes={['cust-mb-4', 'primary-glass']}>
        <div className="d-flex flex-column align-items-center">
          <h3 className="cust-mb-2">{t('maintenance.wentWrong')}</h3>

          {showError && <pre style={{ color: 'red' }}>{error.message}</pre>}

          <p className="text-paragraph-regular text-center cust-mb-2">{t('maintenance.apologise')}</p>
          <div className="d-flex justify-content-center">
            <Button
              meta={{
                name: 'faq',
                title: t('buttons.viewFAQs'),
                type: ButtonType.Primary,
                size: ButtonSize.Large,
              }}
              onClick={() => window.open(`${environment.FAQ_LINK}`)}
            />
          </div>
        </div>
      </Card>
    </div>
  );
});

export default ErrorPanel;